import Component from './src/dialog.vue';

export default Component;
